import React from 'react';
import parse, { DOMNode, Element } from 'html-react-parser';

// DOM node transformers types
type DOMTransformer = (node: DOMNode) => React.ReactNode | undefined;

// Renders <img> tags with 'data-size' attribute correctly styled
const transformImageWithSize: DOMTransformer = (node) => {
  if (node.type === 'tag' && (node as Element).name === 'img') {
    const el = node as Element;
    const {
      src,
      alt = '',
      ['data-size']: size,
      ['data-custom-width']: customWidthStr,
    } = el.attribs || {};

    if (size === undefined && customWidthStr === undefined) {
      console.warn('Suppressed an untagged image in segment text content');
      return <></>;
    }

    let width: string | undefined;
    switch (size) {
      case 'full-width':
        width = '100%';
        break;
      case 'custom':
        const num = parseInt(customWidthStr || '', 10);
        width = !isNaN(num) ? `${num}px` : 'auto';
        break;
      default:
        width = 'auto';
    }

    const style: React.CSSProperties = {
      width: width,
      height: 'auto',
      display: 'inline-block',
      userSelect: 'none',
    };

    return <img key={src} src={src} alt={alt} draggable style={style} />;
  }
  return undefined;
};

// All custom transformers
const transformers: DOMTransformer[] = [transformImageWithSize];

export const parseSegmentHtml = (html: string): React.ReactNode => {
  return parse(html, {
    replace: (domNode: DOMNode) => {
      for (const transform of transformers) {
        const result = transform(domNode);
        if (React.isValidElement(result)) return result; // return only valid JSX Elements
      }
      return undefined;
    },
  });
};
